var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var ErrorManager = /** @class */ (function () {
    function ErrorManager(initial) {
        var _this = this;
        this.errors = {
            current: {}
        };
        this._fields = [];
        if (typeof initial[0] === 'object') {
            var options_1 = initial[0];
            var _loop_1 = function (errorKey) {
                var key = errorKey.left(1).toUpperCase() + errorKey.substring(1);
                this_1._fields.push(key);
                this_1["get".concat(key)] = function () { return _this.errors.current[key]; };
                this_1["set".concat(key)] = function (error) {
                    var _a;
                    if (options_1.autoClearTimeOut) {
                        setTimeout(function () {
                            _this.clear();
                        }, options_1.autoClearTimeOut);
                    }
                    _this.errors.current = __assign(__assign({}, _this.errors.current), (_a = {}, _a[key] = error, _a));
                };
            };
            var this_1 = this;
            for (var _i = 0, _a = options_1.fields; _i < _a.length; _i++) {
                var errorKey = _a[_i];
                _loop_1(errorKey);
            }
        }
        else {
            var _loop_2 = function (errorKey) {
                var key = errorKey.left(1).toUpperCase() + errorKey.substring(1);
                this_2._fields.push(key);
                this_2["get".concat(key)] = function () { return _this.errors.current[key]; };
                this_2["set".concat(key)] = function (error) {
                    var _a;
                    _this.errors.current = __assign(__assign({}, _this.errors.current), (_a = {}, _a[key] = error, _a));
                };
            };
            var this_2 = this;
            for (var _b = 0, initial_1 = initial; _b < initial_1.length; _b++) {
                var errorKey = initial_1[_b];
                _loop_2(errorKey);
            }
        }
    }
    ErrorManager.new = function () {
        var initial = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            initial[_i] = arguments[_i];
        }
        return new this(initial);
    };
    ErrorManager.prototype.hasErrors = function () {
        var _this = this;
        return this._fields.some(function (key) { return !!_this.current[key]; });
    };
    Object.defineProperty(ErrorManager.prototype, "current", {
        get: function () {
            return this.errors.current;
        },
        enumerable: false,
        configurable: true
    });
    ErrorManager.prototype.clear = function () {
        this.errors.current = {};
    };
    return ErrorManager;
}());
export { ErrorManager };
;
